._Submitting_17v8n_1 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
